





import Vue from 'vue'
import Component from 'vue-class-component'

@Component<ChevronCircle>({
  props: {
    color1: {
      type: String,
      default : "#034966"
    },
    color2: {
      type: String,
      default : "#D3D5D7"
    },
  }
})

export default class ChevronCircle extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined
  color2: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
